// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"HomeLogo_logoWrapper__9TPkO"};